import TextArea from 'antd/lib/input/TextArea';
import React from 'react';

const MechanicsRecordTotals = () => {
  return (
    <table
      width="100%"
      cellPadding={4}
      cellSpacing={0}
      style={{ borderCollapse: 'collapse', marginTop: 12 }}
    >
      <tbody>
        <tr>
          <th colSpan={2} align="center">
            Total peças:
          </th>

          <td style={{ width: '30%' }}>
            <TextArea rows={1} />
          </td>
        </tr>

        <tr>
          <th colSpan={2} align="center">
            Total serviços:
          </th>

          <td style={{ width: '30%' }}>
            <TextArea rows={1} />
          </td>
        </tr>

        <tr>
          <th colSpan={2} align="center">
            Gastos adicionais:
          </th>

          <td style={{ width: '30%' }}>
            <TextArea rows={1} />
          </td>
        </tr>

        <tr>
          <th colSpan={2} align="center">
            Total:
          </th>

          <td style={{ width: '30%' }}>
            <TextArea rows={1} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default MechanicsRecordTotals;
